import { render } from "./EditLiquidation2.vue?vue&type=template&id=20f2daf0"
import script from "./EditLiquidation2.vue?vue&type=script&lang=js"
export * from "./EditLiquidation2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__